<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <vue-good-table
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :pagination-options="{
              enabled: true,
              }"
          :rows="rows"
          :columns="columns"
          :globalSearch="true"
          @on-row-dblclick="onRowDoubleClick"
          styleClass="vgt-table striped smalltable"
          :search-options="{
              enabled: true,
              //trigger: 'enter',
              skipDiacritics: true,
              placeholder: 'buscarEnTabla',
            }"
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'acciones'">
              <button v-if="$can('avance-revision-ver')"
                      class="btn btn-success btn-icon btn-sm mr-1"
                      v-on:click="mostrarFormularioRevisionInfo(props.row.id)">
                <i class="fa fa-eye"></i>
              </button>
              <button v-if="$can('avance-revision-modificar') && revisarEstadoParaEditar(props.row)"
                      class="btn btn-primary btn-icon btn-sm"
                      v-on:click="mostrarFormularioRevision(props.row.id)">
                <i class="fa fa-edit"></i>
              </button>
              <button v-if="
                    (
                      $can('avance-revision-eliminar') &&
                      revisarEstadoParaEditar(props.row)
                    )"
                      class="btn btn-danger btn-icon btn-sm ml-1"
                      v-on:click="borrarRevision(props.row.id)" >
                <i class="fa fa-trash"></i>
              </button>

              <button v-if="$can('avance-revision-restaurar') && !revisarEstadoParaEditar(props.row)"
                      class="btn btn-primary btn-icon btn-sm"
                      v-on:click="restaurarRevision(props.row.id)" >
                <i class="fa fa-undo"></i>
              </button>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </vue-good-table>
        <b-modal
            id="modalRevision"
            scrollable
            title="Revision de partidas"
            title-class="font-18"
            size="xl"
            hide-footer

        >
          <revisarAvancePartidas :data="model_revision" />
          <!--<template #modal-footer="{ ok, cancel, hide }">-->
            <!--<h4>Monto valorizado: S/ {{partidas_revision.total}}</h4>-->
            <!-- Emulate built in modal footer ok and cancel button actions-->
          <b-overlay :show="isLoading" rounded="sm">
            <div class="row">
              <div class="col-md-4">
                <button class="btn btn-success mr-2"
                        v-on:click="procesarYCerrarRevision"> <i class="fa fa-lock"></i> Procesar y cerrar </button>

              </div>
              <div class="col-md-8 text-right">
                <button class="btn btn-primary mr-2" v-on:click="guardarRevision"> <i class="fa fa-save"></i> Guardar borrador</button>
                <button class="btn btn-secondary" v-on:click="cerrarFormulario">Salir</button>
              </div>

            </div>


          </b-overlay>
          <!--</template>-->
        </b-modal>
        <b-modal
            id="modalAvanceInfo"
            scrollable
            title="Avance partida"
            title-class="font-18"
            size="lg"
            hide-footer
        >
          <PartidaAvanceInfo :data="partida_avance" />
        </b-modal>

        <b-modal
            id="modalRevisarAvanceInfo"
            scrollable
            title="Info"
            title-class="font-18"
            size="xl"
            hide-footer
        >
          <revisarAvancePartidasInfo :data="partida_avance_info" />
        </b-modal>
    </Layout>
</template>
<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";
    import PartidaAvanceInfo from "@/components/partida-avance-info.vue";
    import revisarAvancePartidas from "@/router/views/avance/revisar-avance-partidas.vue";
    import revisarAvancePartidasInfo from "@/router/views/avance/revisar-avance-partidas-info.vue";

    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Revisión lista",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: {
          revisarAvancePartidas,
          Layout,
          PageHeader,
          PartidaAvanceInfo,
          revisarAvancePartidasInfo
        },
        data() {
            return {
                title: "Avance",
                items: [
                    {
                        text: "Revisión",
                        href: "/",
                    },
                    {
                        text: "Partidas",
                        active: true,
                    },
                ],
                model_revision:{
                  partidas:[]
                },
                isLoading: false,
                columns: [
                  {
                      label: 'id',
                      field: 'id',
                  },
                  {
                    label: 'Expediente',
                    field: 'expediente',
                  },
                  {
                        label: 'Partidas por revisar',
                        field: 'numero_partidas',
                    },
                    {
                      label: 'Estado',
                      field: 'estado_str',
                    },
                    {
                        label: 'Fecha de envio',
                        field: 'fecha',
                    },
                    {
                      label: 'Usuario enviado',
                      field: 'usuario',
                    },
                    {
                        label: 'Acciones',
                        field: 'acciones',
                        width:'12%'
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {
                    },
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                },
                partida_avance:{},
                partida_avance_info:[]
            };
        },

        methods: {
          restaurarRevision(id){

            this.$swal.fire({
              title: '¿Esta seguro de restaurar esta revision de partidas?',
              text: "No se puede revertir esta accion!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Si, restaurar!'
            }).then((result) => {
              if (result.value) {
                this.isLoading=true;
                this.axios.post(process.env.VUE_APP_BACKEND +"/api/revision/restaurar/"+id)
                    .then(() => {
                      this.$swal('Ok',"Se restauro correctamente",'success');
                      this.loadItems();
                    })
                    .catch((r)=>{
                      this.$swal('Cuidado',r.response.data.mensaje,'warning');
                    })
                    .finally(()=>this.isLoading=false)
              }
            })

          },
          revisarEstadoParaEditar(row){
            if(row.estado==2){
              return false;
            }
            return true;

          },
          procesarYCerrarRevision(){
            this.isLoading=true;
            this.axios.post(process.env.VUE_APP_BACKEND +"/api/revision/procesar-y-cerrar",
                {
                  revision_id:this.model_revision.id,
                  partidas:this.model_revision.partidas
                }
            )
                .then(() => {
                  this.$swal('Ok',"Se guardo correctamente",'success');
                  this.$bvModal.hide("modalRevision");
                  this.loadItems();
                })
                .catch((r)=>{
                  this.$swal('Cuidado',r.response.data.mensaje,'warning');
                })
                .finally(()=>this.isLoading=false)
          },


            cerrarFormulario(){
              this.$bvModal.hide("modalRevision");
            },
            guardarRevision(){
              this.isLoading=true;
              this.axios.put(process.env.VUE_APP_BACKEND +"/api/revision/"+this.model_revision.id,
                  this.model_revision
              )
                  .then(() => {
                    this.$swal('Ok',"Se guardo correctamente",'success');
                    this.$bvModal.hide("modalRevision");
                    this.loadItems();
                  })
                  .catch((r)=>{
                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>this.isLoading=false)
            },
            mostrarFormularioRevisionInfo(id){
              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND +"/api/revision/"+id)
                  .then((response) => {
                    this.partida_avance_info=response.data;
                    this.$bvModal.show("modalRevisarAvanceInfo");
                  })
                  .catch((r)=>{
                    this.$swal('Cuidado',r.response.data.mensaje,'warning');
                  })
                  .finally(()=>this.isLoading=false)
            },
            mostrarFormularioRevision(id){

              this.isLoading=true;
              this.axios.get(process.env.VUE_APP_BACKEND +"/api/revision/"+id)
                .then((response) => {
                  this.model_revision=response.data;
                  this.$bvModal.show("modalRevision");
                })
                .catch((r)=>{
                  this.$swal('Cuidado',r.response.data.mensaje,'warning');
                })
                .finally(()=>this.isLoading=false)
            },
            decimal(value)
            {
                if (value===null){
                    return '-'
                }
                else
                {
                    return parseFloat(value).toFixed(2)
                }
            },
            borrarRevision(id){
                this.$swal.fire({
                    title: '¿Esta seguro de eliminar esta revision de partidas?',
                    text: "No se puede revertir esta accion!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Si, borralo!'
                }).then((result) => {
                    if (result.value) {
                        this.isLoading=true;
                        this.axios.delete(process.env.VUE_APP_BACKEND +'/api/revision/'+id)
                        .catch(()=>{
                            this.$swal('error','Error eliminando','error');
                        })
                        .finally(
                            ()=>
                            {
                                this.isLoading=false;
                                this.loadItems();
                            }
                        );
                  }
                })
            },
            onSearch :function(params){
                this.updateParams({page: params.page});
                this.updateParams({searchTerm: params.searchTerm});
                this.loadItems();
            },
            say: function (message) {
                alert(message)
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            // load items is what brings back the rows from server
            loadItems() {
                this.isLoading=true;
                this.axios.get( process.env.VUE_APP_BACKEND+'/api/revision/tabla',{'params':this.serverParams})
                    .then( (response) =>{
                        this.totalRecords = response.data.total_records;
                        this.rows = response.data.data;
                        this.isLoading=false;
                    })
                    .catch(() =>{
                        this.isLoading=false;

                    });
            },
            onRowDoubleClick(){
                //alert(params);
            }
        },
        mounted() {
            this.loadItems();
        }
    };
</script>

<style>
    .smalltable{
        font-size: 12px !important;
    }

</style>
